import styled from 'styled-components';

/**
 * The add code form under a price table: a shaded tool bar with a left accent, so it reads as a tool and not as another
 * payment method row.
 */
export const AddCodeForm = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1.2rem;
    margin-top: 0.8rem;
    padding: 1rem 1.2rem;
    background: ${props => props.theme.colors.subtle.light};
    border: 0.1rem dashed ${props => props.theme.colors.input.border};
    border-left: 0.3rem solid ${props => props.theme.colors.text.subtleSecondary};
    border-radius: 0.4rem;
`;

export const AddCodeFields = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.6rem;
`;

export const AddCodeTitle = styled.span`
    margin-right: 0.6rem;
    font-family: ${props => props.theme.text.font.medium};
    font-size: ${props => props.theme.text.size.small};
    color: ${props => props.theme.colors.text.secondary};
`;

/** The other way in, kept apart from the fields at the far end of the bar. */
export const AddCodeAside = styled.div`
    margin-left: auto;
`;
